import { useScanner } from '../../../hooks/scanner.hook'
import { useEffect, useState } from 'react'
import { useGoToInventoryProductList } from '../product-list/InventoryProductList.navigator'
import { manageError } from '../../../utils/errors/error.handler'
import { getContainerFromScan } from 'client/scanner/scanner.client'
import { useAtom } from 'jotai'
import { inventoryFixOriginInfoAtom } from '../InventoryFix.state'
import { useParams } from 'react-router-dom'
import { getContainersInLocation } from 'client/location/location.client'
import { toast } from 'react-toastify'

export const useScanContainer = () => {
  const {
    keys,
    getScan
  } = useScanner()
  const inventoryProductList = useGoToInventoryProductList()
  const [, setOrigin] = useAtom(inventoryFixOriginInfoAtom)
  const { location } = useParams()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [containers, setContainers] = useState<string[]>([])

  /* Get containers from origin */
  useEffect(() => {
    if (origin != null) {
      setIsLoading(true)
      getContainersInLocation(location as string)
        .then(containers => setContainers(containers.map(it => it.name)))
        .catch(e => {
          console.error(e)
          toast.error(e.message as string)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [])

  useEffect(() => {
    const scanned = getScan()
    if (scanned) {
      getContainerFromScan(scanned)
        .then(origin => {
          if (!containers.find(it => it === origin.container.name)) {
            toast.error(`La ubicación escaneada no está vinculada a esta tarima. Escanea la ubicación correcta.`)
          }
          else{
            setOrigin(origin)
            inventoryProductList.go(origin)
          }
        })
        .catch(manageError(`ScanContainerLocation.hooks.ts#useEffect ${scanned}`))
    }
  }, [keys])

  return { 
    isLoading
  }

}
